export default __webpack_public_path__ + "static/media/twitter.29059a5d.svg";